import type { ReactNode } from 'react';

import Image from '../../shared/components/Image';
import { LanguagesIcon, SettingsIcon, HelpIcon, DepositIcon, ExitIcon } from './shared/SettingsModal.icons';
import { LANGUAGE, SETTINGS, HELP, LOBBY, DEPOSIT, EXIT } from './constants';
import type { TabType } from './types';

const lobbyIconSrc = '/ui/EGTD_only_logo';

export type TabsMeta = {
  icon: ReactNode;
  text: string; // i18n key
  headerText?: string; // i18n key (optional)
};

export const TABS_META: Record<TabType, TabsMeta> = {
  [LOBBY]: {
    icon: <Image src={lobbyIconSrc} alt="lobby" manualAffix=".svg" />,
    text: 'tabs.names.LOBBY_TAB',
  },
  [LANGUAGE]: {
    icon: <LanguagesIcon />,
    text: 'setting_tabs.names.language_tab',
    headerText: 'setting_tabs.names.language'
  },
  [SETTINGS]: { icon: <SettingsIcon />, text: 'setting_tabs.names.options' },
  [HELP]: { icon: <HelpIcon />, text: 'setting_tabs.names.help' },
  [DEPOSIT]: { icon: <DepositIcon />, text: 'setting_tabs.names.deposit' },
  [EXIT]: { icon: <ExitIcon />, text: 'generic_exit' }
};
